var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-toast",
    { staticClass: "risk-result", attrs: { message: _vm.message } },
    [
      _c("div", {
        staticClass: "toast-body",
        domProps: { innerHTML: _vm._s(_vm.$t("toast.password-updated")) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }